<template>
	<div class="wrap">
		<div class="head">
			<div class="center"><img class="logo" src="../../assets/images/logo_gys.png" /></div>
		</div>
		<div class="main">
			<img class="bg" src="../../assets/images/login_banner.png" />
			<div class="register_main">
				<div class="step1" v-if="reg_step==1">
					<p class="title">注册账号</p>
					<el-input v-model="yqm" disabled class="el_input el_in2" v-if="yqm">
						<p slot="prefix" class="txts">邀请码</p>
					</el-input>
					<el-input v-model="reg_nickname" placeholder="输入公司名称" class="el_input el_in2">
						<p slot="prefix" class="txts">公司名称</p>
					</el-input>
					<el-input v-model="reg_phone" placeholder="输入手机号" class="el_input el_in2">
						<p slot="prefix" class="txts">手机号码</p>
					</el-input>
          <el-input v-model="reg_captcha" placeholder="请输入图形验证码" class="el_input el_in2">
            <p slot="prefix" class="txts">验证码</p>
          </el-input>
          <div class="mt-4">
            <img class="w-40" :src="captcha_url" @click="refreshCaptcha" />
          </div>
					<el-input v-model="reg_code" placeholder="短信验证码" class="el_input el_in2">
						<p slot="prefix" class="txts">验证码</p>
						<p slot="suffix" class="getcode" @click="getPhoneCode('1')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
					</el-input>
					<el-input v-model="reg_pwd" placeholder="输入密码" type="password"  class="el_input el_in2">
						<p slot="prefix" class="txts">设置密码</p>
					</el-input>
					<el-input v-model="reg_pwd_confirm" type="password" placeholder="再次输入密码" class="el_input el_in2">
						<p slot="prefix" class="txts">确认密码</p>
					</el-input>
					<p class="register_btn" @click="regSubmit">注册</p>
					<div class="check_line">
						<label class="la"><el-checkbox v-model="reg_checked"></el-checkbox>我已同意并阅读</label>
						<p class="link" @click="$router.push('./notice?type=4&id=1')">《轻货供应链用户协议》</p>
					</div>
				</div>
				<div class="step2" v-if="reg_step==2" v-loading="loadingCode">
					<p class="title">扫码关注公众号</p>
					<img class="code" :src="imageCode" />
					<p class="code_txt">打开手机微信，扫描二维码</p>
				</div>
			</div>
		</div>
		<div class="foot">
			<p>地址：广东省深圳市龙华区XX街道000室</p>
			<p>XXX有限公司  版权所有2022-2029  粤ICP备00000000号</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import common from '../../assets/js/utils/common';
import config from "@/assets/js/conf/config";
export default {
	name: "login",
	data(){
		return{
			reg_nickname: "",
			reg_phone:"",
			reg_code:"",
			reg_pwd:"",
			reg_pwd_confirm:"",
			reg_step:1,
			reg_checked:false,
			loadingCode:false,
			imageCode:"",
			is_reg_submit:false,
			is_get_phone_code:false,
			phone_second:60,
			checkBindTimer:null,
			userinfo:"",
			yqm:"",
			yq_grade:"",
      captcha_url:"",
      reg_captcha:"",
		}
	},
	components:{
		
	},
	computed:{
		...mapState({
			ucmenu:(state)=>state.login.ucmenu,
		}),
	},
	created(){		
		var query = this.$route.query
		if(query.yqm){
			this.yqm = query.yqm
			this.yq_grade = query.yq_grade
		}
	},
	mounted(){
		this.refreshCaptcha()
	},
	methods:{
		...mapActions({
			getCodeData:"login/getCodeData",
			DoRegister:"login/DoRegister",
			getQrcodeData:"login/getQrcodeData",
			checkWxBind:"login/checkWxBind",
			getUcenterMenu:"login/getUcenterMenu",
		}),
		regSubmit(){//注册提交
		if(!this.reg_nickname){
			this.$message({message: '请输入公司名称',type: 'error',});
			return false
		}
			if(!common._verify_mobile(this.reg_phone)){
				this.$message({message: '请输入正确手机号',type: 'error',});
				return false
			}
			if(!this.reg_code){
				this.$message({message: '请获取短信验证码',type: 'error',});
				return false
			}
			if(!this.reg_pwd){
				this.$message({message: '请输入密码',type: 'error',});
				return false
			}
			if(!this.reg_pwd_confirm){
				this.$message({message: '请再次输入密码',type: 'error',});
				return false
			}
			if(this.reg_pwd != this.reg_pwd_confirm){
				this.$message({message: '请确保两次输入的密码一致',type: 'error',});
				return false
			}
			if(!this.reg_checked){
				this.$message({message: '请阅读并同意用户协议',type: 'error',});
				return false
			}
			if(!this.is_reg_submit){
				this.is_reg_submit = true
				this.DoRegister({data:{
						nickname:this.reg_nickname,
						mobile:this.reg_phone,
						code:this.reg_code,
						password:this.reg_pwd,
						true_password:this.reg_pwd_confirm,
						yqm:this.yqm,
						yq_grade:this.yq_grade,
					},success:(res)=>{
					if(res.code===200){
						console.log('register success',res)
						this.$message({message: '注册成功~',type: 'success',});
						this.reg_step = 2
						this.loadingCode = true
						this.getLoginCode(this.reg_phone,true)
						setTimeout(()=>{
							this.is_reg_submit = false
							this.reg_phone = ''
							this.reg_code = ''
							this.reg_pwd = ''
							this.reg_pwd_confirm = ''
						},1500)
					} else {
						this.is_reg_submit = false
						this.$message({message: res.msg,type: 'error',});
					}
				}})
			}
		},
		getPhoneCode(ev){//获取短信验证码
			let phone = this.reg_phone
			if(!common._verify_mobile(phone)){
				this.$message({message: '请输入正确手机号',type: 'error',});
				return false
			}

      if(!this.reg_captcha){
        this.$message({message: '请先输入图形验证码',type: 'error',});
        return false
      }
			if(!this.is_get_phone_code){
				this.is_get_phone_code = true
				this.getCodeData({data:{
						mobile:phone,
						event:ev,
            captcha: this.reg_captcha,
					},success:(res)=>{
					if(res.code===200){
						console.log('get phone code',res)
						this.$message({message: '发送成功~',type: 'success',});
						let timer = setInterval(()=>{
							this.phone_second -= 1
							if(this.phone_second == 0){
								clearInterval(timer)
								this.phone_second = 60
								this.is_get_phone_code = false
							}
						},1000)
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.is_get_phone_code = false
					}
				}})
			}
			
		},
		getLoginCode(phone='',isCheck=false,type='2'){//获取登录二维码,type=1表示直接通过二维码扫码登录，不需要传手机号
			this.getQrcodeData({data:{
					mobile:phone,
					level:'3',
					bind_uid:'0',
					type:type,
				},success:(res)=>{
				if(res.code===200){
					console.log('get qr code',res)
					this.imageCode = res.msg.ticket_img
					setTimeout(()=>{this.loadingCode = false},1000)
					if(isCheck){
						this.int_uid = res.msg.int_uid
						this.checkBind(res.msg.int_uid)
					}
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		checkBind(id){//检测是否微信绑定成功
			this.checkWxBind({data:{
					int_uid:id,
				},success:(res)=>{
				console.log('check login',res)
				if(res.code===200){
					this.userinfo = res.data.userinfo
					this.avatar = res.data.userinfo.avatar
					this.$message({message: res.msg,type: 'success',});
					this.getUCmenu()
					let timer = setInterval(()=>{
						if(this.ucmenu.length>0){
							clearInterval(timer)
							setTimeout(()=>{
								this.$router.replace(this.ucmenu[0].url +'?menuId='+this.ucmenu[0].menu_id)
							},300)
						}
					},100)
				} else {
					this.checkBindTimer = setTimeout(()=>{
						this.checkBind(this.int_uid)
					},1500)
				}
			}})
		},
		getUCmenu(){
			this.getUcenterMenu({data:{},success:(res)=>{
				if(res.status==200){
					console.log('getUCmenu',res)
					// this.employeeData.data = res.data
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
    refreshCaptcha(){
      this.captcha_url = config.baseApi + '/business/login/captcha?_t=' + new Date().getTime()
    },
        },
	beforeDestroy() {
		clearTimeout(this.checkBindTimer)
	},
}
</script>

<style scoped>
.wrap{background: #fff;}
.head{width: 100%;height: 140px;background: #fff;}
.head .center{display: flex;align-items: center;}
.head .logo{width: 257px;height: 60px;}
.main{width: 100%;height: auto;position: relative;display: flex;}
.main .bg{width: 100%;height: auto;position: relative;z-index: 1;}
.foot{margin: 40px 0;text-align: center;}
.foot>p{font-size: 12px;line-height: 22px;color: #666666;}
.register_main{width: 346px;height: auto;box-sizing: border-box;padding: 33px 22px;background: #fff;position: absolute;top: 120px;right: 230px;z-index: 2;}
.register_main .title{line-height: 1;font-size: 20px;margin-bottom: 16px;}
.register_main .register_btn{width: 100%;height: 38px;border-radius: 4px;background: #fb5758;display: flex;justify-content: center;align-items: center;color: #ffffff;font-size: 14px;cursor: pointer;margin-top: 35px;}
.register_main .check_line{display: flex;align-items: center;font-size: 14px;margin-top: 14px;}
.register_main .code{display: block;width: 155px;height: 155px;margin: 50px auto 0;}
.register_main .code_txt{margin-top: 28px;text-align: center;font-size: 14px;color: #666666;}
.register_main .check_line .link{color: #fb5758;cursor: pointer;}

</style>
<style>

.register_main .check_line .el-checkbox{margin-right: 8px;margin-top: 2px;}
.el-checkbox__input.is-focus .el-checkbox__inner{border-color: #DCDFE6 !important;}
.el-checkbox__input.is-checked .el-checkbox__inner{background-color: #fb5758 !important;border-color: #fb5758 !important;}
.el_input{display: flex;margin: 14px 0 0 !important;}
.el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
.el_input .el-input__inner:focus{border-color: var(--red);}
.el_input.el_in2 .el-input__inner{padding-left: 90px;}
.el_input .el-input__prefix{left: 2px;top: 1px}
.el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
.el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
.el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;padding-left: 10px;}
.el_input .el-input__suffix{display: flex;}
.el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;}
.el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
</style>